export default __webpack_public_path__ + "static/media/Lion-circuits.c2ce01a5.webp";